import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { useTranslation } from "react-i18next";
import { getInboundStateData } from "../../../../utils/labelColorText";

export const RelationInboundLineCard = (props) => {
    const theme = useTheme();
    const { t,i18n } = useTranslation();

    let status = props.state;
    

    const { labelcolor, labeltext } = getInboundStateData(props.state, theme);

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box>
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <Text bold>{props.inbound.reference}</Text>
                        }
                    </Box>

                    <Box
                        sx={{
                            mt:4,
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <>
                                <Text>{props.product.sku}</Text>
                                <Text light>{props.product.description}</Text>
                            </>
                        }
                    </Box>

                    <TopRight>
                        <CardLabel hasright variant={labelcolor} position="child-tr">
                            {t(labeltext)}
                        </CardLabel>
                        <CardLabel 
                            variant={theme.palette.mode === "dark" ? "greyLight" : "grey"}
                            hasleft 
                            fitted
                            colorflip={theme.palette.mode !== "dark"}
                            position="child-tr"
                        >
                            {props.skeleton ? "N/A" : props.amountForecasted}
                        </CardLabel>
                    </TopRight>
                </Box>
            </Box>
        </BaseCard>
    )
}

export const WarehouseReturnReasonCard = (props) => {
    const theme = useTheme();
    const { t,i18n } = useTranslation();

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box>
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <Text bold>{props.description}</Text>
                        }
                    </Box>

                    {/* <Box
                        sx={{
                            mt:4,
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/> 
                            :
                            <>
                            erkk
                            </>
                        }
                    </Box> */}
                </Box>
            </Box>
        </BaseCard>
    )
}
